import { useMutation, useQueryClient } from "@tanstack/react-query";
import { roleService } from "@/features/roles/services/roleService";
import { handleApiError, toastMutationSuccess } from "@/lib/error-handler";
import { queryKeys } from "@/lib/query-keys";
import type { CreateRoleInput, UpdateRoleInput } from "@/features/roles/types/role";

export function useCreateRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateRoleInput) => roleService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.roles.all });
      toastMutationSuccess(null, { fallbackMessage: "تم إنشاء الدور بنجاح" });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useUpdateRole(code: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateRoleInput) => roleService.update(code, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.roles.all });
      toastMutationSuccess(null, { fallbackMessage: "تم تحديث الدور بنجاح" });
    },
    onError: (error) => handleApiError(error),
  });
}

export function useDeleteRole() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => roleService.remove(code),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.roles.all });
      toastMutationSuccess(null, { fallbackMessage: "تم حذف الدور بنجاح" });
    },
    onError: (error) => handleApiError(error),
  });
}
